import { computed } from '@vue/composition-api';
import { getRuntimeVM } from './util/runtime';
export default function useRouter() {
    var vm = getRuntimeVM();
    var route = computed(function () { return vm.$route; });
    return { route: route, router: vm.$router };
}
